import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import { Home, Users, DollarSign, FileText, LogOut, User, Folder, Search, Shield } from 'lucide-react';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { ADMIN_EMAIL } from '../config';

function Sidebar({ activeTab, setActiveTab }) {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdmin = () => {
      const user = auth.currentUser;
      if (user && user.email === ADMIN_EMAIL) {
        setIsAdmin(true);
      }
    };
    
    const unsubscribe = auth.onAuthStateChanged(() => {
      checkAdmin();
    });
    
    checkAdmin();
    
    return unsubscribe;
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/signin');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleProfileClick = () => {
    setActiveTab('settings');
  };

  return (
    <div className="sidebar">
      <div className="sidebar-top">
        <div className="logo-circle">
          <img src="/ugc3-logo.png" alt="UGC3 Logo" />
        </div>
      </div>

      <div className="sidebar-nav">
        <div
          className={`nav-icon ${activeTab === 'home' ? 'active' : ''}`}
          onClick={() => setActiveTab('home')}
          data-tooltip-id="sidebar-tooltip"
          data-tooltip-content="Home"
        >
          <Home size={20} />
        </div>
        <div
          className={`nav-icon ${activeTab === 'campaigns' ? 'active' : ''}`}
          onClick={() => setActiveTab('campaigns')}
          data-tooltip-id="sidebar-tooltip"
          data-tooltip-content="Campaigns"
        >
          <Folder size={20} />
        </div>
        <div
          className={`nav-icon ${activeTab === 'create' ? 'active' : ''}`}
          onClick={() => setActiveTab('create')}
          data-tooltip-id="sidebar-tooltip"
          data-tooltip-content="Creators"
        >
          <Users size={20} />
        </div>
        {/* Performance - Hidden from sidebar but visible on main dashboard as coming soon */}
        {/* <div
          className={`nav-icon ${activeTab === 'performance' ? 'active' : ''}`}
          onClick={() => setActiveTab('performance')}
          data-tooltip-id="sidebar-tooltip"
          data-tooltip-content="Performance"
        >
          <DollarSign size={20} />
        </div> */}
        <div
          className={`nav-icon ${activeTab === 'handin' ? 'active' : ''}`}
          onClick={() => setActiveTab('handin')}
          data-tooltip-id="sidebar-tooltip"
          data-tooltip-content="Hand-in"
        >
          <FileText size={20} />
        </div>
        {isAdmin && (
          <div
            className={`nav-icon ${activeTab === 'admin' ? 'active' : ''}`}
            onClick={() => setActiveTab('admin')}
            data-tooltip-id="sidebar-tooltip"
            data-tooltip-content="Admin - Brand Sign-ups"
          >
            <Shield size={20} />
          </div>
        )}

      </div>

      <div className="sidebar-bottom">
        <div 
          className={`nav-icon ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={handleProfileClick}
          style={{ cursor: 'pointer' }}
          data-tooltip-id="sidebar-tooltip"
          data-tooltip-content="Settings"
        >
          <User size={20} />
        </div>
        <div className="nav-icon" onClick={handleLogout} style={{ cursor: 'pointer' }} data-tooltip-id="sidebar-tooltip" data-tooltip-content="Logout"><LogOut size={20} /></div>
      </div>
      <Tooltip id="sidebar-tooltip" place="right" style={{ zIndex: 1000 }} />
    </div>
  );
}

export default Sidebar;
